import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { formatDuration } from '@/pages/dashboard/shared/analytics-utils'

interface Props {
  from: string
  totalMessages: number
  totalThreads: number
  averageThreadDuration: number
  totalThreadDuration: number
  averageThreadMessages: number
}

export const MonthlySummaryCard = ({
  from,
  totalMessages,
  totalThreads,
  averageThreadDuration,
  totalThreadDuration,
  averageThreadMessages,
}: Props): JSX.Element => (
  <Card className="w-full">
    <CardHeader>
      <CardTitle className="text-2xl font-bold">
        Statistika za{' '}
        {new Date(from).toLocaleString('sr-Latn', { month: 'long', year: 'numeric' }).toUpperCase()}
      </CardTitle>
      <CardDescription>Sumirani podaci za tekući mesec</CardDescription>
    </CardHeader>
    <CardContent className="flex flex-col gap-6">
      <div className="space-y-1">
        <p className="text-muted-foreground text-sm">Ukupno poruka</p>
        <p className="text-3xl font-semibold">{totalMessages ?? '-'}</p>
      </div>

      <div className="space-y-1">
        <p className="text-muted-foreground text-sm">Ukupno razgovora</p>
        <p className="text-3xl font-semibold">{totalThreads ?? '-'}</p>
      </div>

      <div className="space-y-1">
        <p className="text-muted-foreground text-sm">Prosečan broj poruka po razgovoru</p>
        <p className="text-3xl font-semibold">
          {averageThreadMessages ? Number(averageThreadMessages).toFixed(2) : '-'}
        </p>
      </div>

      <div className="space-y-1">
        <p className="text-muted-foreground text-sm">Ukupno trajanje razgovora</p>
        <p className="text-3xl font-semibold">
          {totalThreadDuration ? formatDuration(totalThreadDuration) : '-'}
        </p>
      </div>
      <div className="space-y-1">
        <p className="text-muted-foreground text-sm">Prosečno trajanje razgovora</p>
        <p className="text-3xl font-semibold">
          {averageThreadDuration ? formatDuration(averageThreadDuration) : '-'}
        </p>
      </div>
    </CardContent>
  </Card>
)
